module.exports = __webpack_public_path__ + "img/Winner-8.066e5f04.jpg";